import type { CSSProperties } from "react";

export const MenuIcon = ({
  size = "16",
  style = {},
}: {
  size?: number | string;
  style?: CSSProperties;
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 175 105"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <rect width="175" height="15" rx="7.5" fill="#333333" />
      <rect y="45" width="175" height="15" rx="7.5" fill="#333333" />
      <rect y="90" width="175" height="15" rx="7.5" fill="#333333" />
    </svg>
  );
};
